import React, { useState } from "react";
import TestimonialCard from "../components/TestimonialCard";
import TestimonialModal from "../components/TestimonialModal";
import { testimonials } from "../data/testimonials";

const Testimonials = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section className="section">
      <div className="container">

        {/* ===== Intro / Header Block ===== */}
        <div
          style={{
            maxWidth: "760px",
            marginBottom: "3rem",
            padding: "26px 30px",
            borderRadius: "18px",
            background: "linear-gradient(180deg, #f8fbff 0%, #ffffff 100%)",
            border: "1px solid #e6ecf5",
          }}
        >
          <h1
            className="heading-secondary"
            style={{ marginBottom: "14px" }}
          >
            Success Stories
          </h1>

          <p
            style={{
              fontSize: "1.05rem",
              fontWeight: 500,
              color: "var(--text-primary)",
              marginBottom: "10px",
            }}
          >
            Real stories. Real effort. Real outcomes.
          </p>

          <p
            style={{
              fontSize: "0.95rem",
              color: "var(--text-secondary)",
              lineHeight: "1.65",
              marginBottom: "14px",
            }}
          >
            These are unfiltered experiences from students who’ve been part of
            our live cohorts — shared exactly as they were, without polishing
            or scripting.
          </p>

          <div
            style={{
              display: "inline-block",
              fontSize: "0.8rem",
              color: "#2f5cf1",
              background: "#eef2ff",
              padding: "6px 12px",
              borderRadius: "10px",
              fontWeight: 500,
            }}
          >
            No edits • No AI-generated content
          </div>
        </div>

        {/* ===== Testimonials Grid ===== */}
        <div className="grid grid-3 gap-lg">
          {testimonials.map((t) => (
            <TestimonialCard
              key={t.id}
              quote={t.review}
              name={t.name}
              role={t.college}
              image={t.photo}
              linkedin={t.linkedin}
              showReadMore={t.review.length > 300}
              onReadMore={() => setSelected(t)}
            />
          ))}
        </div>

        {/* ===== Entity / Legal Note ===== */}
        <p
          className="text-xs mt-xl"
          style={{
            color: "var(--text-secondary)",
            maxWidth: "760px",
            lineHeight: "1.6",
            paddingTop: "18px",
            borderTop: "1px dashed #e5e9f2",
          }}
        >
          These testimonials are from cohorts conducted under{" "}
          <strong>Alvron Partners LLP</strong>.
          <br />
          <strong>Intlrr</strong> is an educational initiative of Alvron Partners
          LLP.
        </p>
      </div>

      {/* ===== Popup Modal ===== */}
      <TestimonialModal
        testimonial={selected}
        onClose={() => setSelected(null)}
      />
    </section>
  );
};

export default Testimonials;
